import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.urnResource('profession')
@doc.path('/professions/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractProfessionModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_ProfessionReference;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		reference: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare reference: string;
	@doc.string declare label: string;
}

interface AbstractProfessionModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractProfessionModel;
